import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { SalaryPeriod } from '../../../types';
import { useVisibleJobs } from '../../utils';
import { useAmountSalaries } from '../utils';
import { CurrencyAndPeriodDropdown } from './CurrencyAndPeriodDropdown';
import { useJobFilters } from './JobFilterProvider';

export function PeriodSelect() {
  const { t } = useTranslation();
  const { selectedPeriod, setSelectedPeriod } = useJobFilters();
  const visibleJobs = useVisibleJobs();
  const amountSalaries = useAmountSalaries();

  const periodTranslations = useMemo(
    () =>
      ({
        hour: t('Per Hour'),
        day: t('Per Day'),
        week: t('Per Week'),
        month: t('Per Month'),
        year: t('Per Year'),
        shift: t('Per Shift')
      }) as const,
    [t]
  );

  const periods = useMemo(() => {
    const periodNames = Object.keys(periodTranslations);

    return [...new Set(amountSalaries.map((s) => s.period))].sort(
      (a, b) => periodNames.indexOf(a) - periodNames.indexOf(b)
    );
  }, [visibleJobs, periodTranslations, amountSalaries]);

  return (
    <CurrencyAndPeriodDropdown
      items={periods}
      selectedItem={selectedPeriod}
      setSelectedItem={setSelectedPeriod}
      formatItem={(period: SalaryPeriod) => periodTranslations[period]}
    />
  );
}
